/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { useLocation, Route, Switch } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminNavbar from "../components/Navbars/AdminNavbar";
// import AdminFooter from "components/Footers/AdminFooter.js";
import AdminFooter from "../components/Footers/AdminFooter";
import Sidebar from "../components/Sidebar/Sidebar";

import { Routes } from "../routes";

const SuperAdmin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  // var document: Document;
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/super-admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < Routes.superAdmin.length; i++) {
      let localPath = props.location.pathname.split('/');
      if (!isNaN(localPath[localPath.length - 1])) {
        localPath.pop();
        let s = localPath.join('/') + "/:id";
        // console.log(s);
        // props.location.pathname = s;
        if (s.indexOf(Routes.superAdmin[i].layout + Routes.superAdmin[i].path) !== -1) {
          return Routes.superAdmin[i].name;
        }
      }
      if (props.location.pathname.indexOf(Routes.superAdmin[i].layout + Routes.superAdmin[i].path) !== -1) {
        return Routes.superAdmin[i].name;
      }
    }
    return "Brand";
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={Routes.superAdmin}
        logo={{
          innerLink: "/admin/index",
          imgSrc: require("../assets/img/brand/argon-react.png").default,
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props.location.pathname)}
        />
        <Switch>
          {getRoutes(Routes.superAdmin)}
          {/* <Redirect from="*" to="/teacher/index" /> */}
        </Switch>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default SuperAdmin;
